import React from "react";
import "./404.css";

function LostPage() {
  document.title = "404 - Page Not Found";

  return (
    <div className="404">
      <div className="error-wrap">
        <h4>Maaf, halaman ini tidak tersedia.</h4>
        <p>
          Tautan yang Anda ikuti mungkin rusak, atau halaman mungkin telah
          dihapus.<a href="/"> Kembali ke Teka-Teki Al-Qur'an</a>
        </p>
      </div>
      <div className="circle"></div>
      <div className="diamond"></div>
    </div>
  );
}

export default LostPage;
